package com.anjuros.website.redesign.util

/** Page paths used by the redesigned pages. */
object RdRoute {
    const val HOME = "/"
    const val DESIGNS = "/website-templates-uk"
    const val TRADES = "/website-design-for-uk-trades"
    const val PORTAL = "/job-management-portal"
    const val PRICING = "/website-design-pricing-uk"
    const val ABOUT = "/about"
    const val FAQ = "/faq"
    const val BLOG = "/blog"
    const val SEO = "/seo-services"
    const val CONTACT_FORMS = "/contact-forms"
    const val PRIVACY = "/privacy-policy"
    const val CONTACT = "/#contact"

    /** The "All website designs" list on the designs page. */
    const val DESIGNS_CATALOGUE = "/website-templates-uk#catalogue"

    const val ELECTRICIAN = "/electrician-website-design-uk"
    const val DECORATOR = "/decorator-website-design-uk"
    const val HANDYMAN = "/handyman-website-design-uk"
    const val HAIRDRESSER = "/hairdresser-website-design-uk"
    const val DOG_WALKER = "/dog-walker-website-design-uk"
    const val BAKER = "/baker-website-design-uk"
    const val INSTRUCTOR = "/instructor-website-design-uk"
    const val PUB = "/pub-website-design-uk"
}

/** Images used by the redesigned pages, with their intrinsic sizes to avoid layout shift. */
object RdImage {
    data class Asset(val src: String, val width: Int, val height: Int)

    val LOGO = Asset("/logoanjuros.PNG", 600, 150)
    val DESIGN_ELECTRICIAN = Asset("/template6-main.webp", 1235, 822)
    val DESIGN_DECORATOR = Asset("/template4-main.webp", 1123, 750)
    val DESIGN_HANDYMAN = Asset("/template2-main.webp", 600, 401)
    val DESIGN_DOG_WALKER = Asset("/template9-main.jpeg", 600, 400)
    val DESIGN_HAIRDRESSER = Asset("/template1-main.webp", 1124, 750)
    val DESIGN_BAKER = Asset("/template5-main.jpeg", 600, 400)
    val DESIGN_INSTRUCTOR = Asset("/template10_main.jpg", 1920, 1278)
    val DESIGN_PUB = Asset("/template8_main.jpg", 2073, 1382)
    val PORTAL_DESKTOP = Asset("/portal_mock2.png", 1000, 1000)
    val PORTAL_PHONE_ENQUIRY = Asset("/portal_mock1.png", 740, 1400)
    val PORTAL_PHONE_CLIENTS = Asset("/portal_mock3.png", 1480, 2800)
    val PORTAL_PHONE_ACTIONS = Asset("/portal_mock4.png", 1480, 2800)
    val SEO_CERTIFICATE = Asset("/seo_certificate.jpg", 1541, 1130)
    val AVATAR = Asset("/avatar.svg", 264, 280)
    val AVATAR_BLINK = Asset("/avatar_blink.svg", 264, 280)
    val WORK_GUESTHOUSE_LAPTOP = Asset("/showcase3.png", 1000, 1000)
    val WORK_GUESTHOUSE_PHONE = Asset("/showcase1.png", 592, 1120)
    val BLOG_WHY_WEBSITE = Asset("/blog1_img1.jpg", 1536, 1024)
    val BLOG_FEATURES = Asset("/15_features_sole_trader_website_should_have.jpg", 1536, 963)
    val BLOG_MORE_CUSTOMERS = Asset("/how_to_get_more_customers.jpg", 1536, 1024)
    val BLOG_COST = Asset("/how_much_does_a_website_cost.jpg", 1536, 1024)
}

const val SITE_URL = "https://www.soletraderwebsite.co.uk"

/** External links: profiles and the client project on the About page, and the SEO certificate. */
object RdExternal {
    const val LINKEDIN = "https://www.linkedin.com/in/justyna-rosielewska-94a7b6109/"
    const val DEVELOPER_PORTFOLIO = "https://www.anjurosdevelopment.com/"
    const val GUESTHOUSE = "https://www.noclegiskwarek.com/?ln=en"
    const val SEO_CERTIFICATE = "https://www.udemy.com/certificate/UC-8c5b0764-a676-4910-b50d-fff00275283a/"
}
